import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class AdminRoleEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "AdminRole";
        this.primaryEnterpriseComponent = "AdminRole";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminRole";
        eom.enterpriseComponent = "AdminRole";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminRolePrivilege";
        eom.enterpriseComponent = "AdminRolePrivilege";
        eom.relationship = "AdminRoleAdminPrivilege";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminRoleEmployee";
        eom.enterpriseComponent = "AdminRoleEmployee";
        eom.relationship = "AdminRoleAdminRoleEmployee";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default AdminRoleEnterpriseObjectMetadata;